
import schema from '../schema/needs'
import {writeFileXLSX,utils} from "xlsx";
import {dbClient} from "../../lib/dbClient";

const collection = "needsAnalysis";


function defaultValueForType(dataType){
    let defaultValue = false;

    switch (dataType) {
        case 1:
            defaultValue = '';
            break;

        default:
            defaultValue = '';
    }

    return defaultValue;
}

function defaultAnswers(questions) {

    let answers = {};
    for (let questionId in questions) {
        let question = questions[questionId];
        answers[questionId] = defaultAnswer(question);
    }

    return answers;
}

function generateBlankComment(qId) {

    let comment = {
        id: 0, //should be set at first save
        reviewer: "",
        question: qId,
        ts: 0,
        value: "",
        voice: "",
        session: "", //session id
        respondent: "",
        status: 1 // 0 to disregard, 2 for important
    }

    return comment
}

function generateSession() {



    let session = {
        id: 0, //should be set at first save
        reviewer: "",
        ts: 0,
        voice: "",
        respondent: "",
        notes: "",
        date: "",
        respondentTitle: ""

    }

    return session
}

function generateRespondent() {



    let respondent = {
        id: 0, //should be set at first save
        reviewer: "",
        ts: 0,
        name: "",
        notes: "",
        title: ""
    }

    return respondent
}

function defaultComments(questions) {

    let comments = {};
    for (let questionId in questions) {
        //let question = questions[questionId];
        comments[questionId] = {};
    }

    return comments;
}

function defaultAnswer(question) {
    let answer = {
        lastEdit: null,
        voices: {}
    };
    Object.keys(schema.voiceOptions).forEach((voice) => {
        answer.voices[voice] = {
            reviewer: "",
            ts: 0,
            value: defaultValueForType(question.type),
            edits: []
        };
    })

    answer.voices.notes = {
        reviewer: "",
        ts: 0,
        value: defaultValueForType(1),
        edits: []
    };

    return answer;
}

function getCount(){
    let token = localStorage.getItem("token");

    const supabase = dbClient(token)

    return supabase.from(collection).select('id',{count: 'exact'}).then((response)=>{

        console.log("count res",response)
        if(response.count){
            return response.count
        }else{
            return 0
        }
    })

    // return client.query(
    //     q.Count(
    //         q.Paginate(
    //             q.Documents(q.Collection(collection)),
    //             {size: 10000}
    //         )
    //     ),
    // ).then((response) => {
    //
    //     console.log(response)
    //
    //     if(response.data){
    //         return response.data
    //     }else{
    //         throw new Error("Network error.");
    //     }
    // })
}
//
// function getSearchForColumn(text, column, size=100){
//     let token = localStorage.getItem("token");
//
//
//
//
//     return client.query(
//         q.Map(
//             q.Paginate(
//                 q.Match(
//                     q.Index('needsAnalysis_by_ts_city_state_se_org_created'),
//                     // You need to provide values for all fields that come before "created"
//                     // or use binding parameters with Select
//                     [
//                         // Provide specific values for preceding fields or use null/wildcards
//                         null, // ts (reverse)
//                         null, // organizationName
//                         null, // city
//                         null, // state
//                         null, // lastEdit.ts
//                         null, // lastEdit.user
//                         null, // ref.id
//                         null, // seName
//                         null, // pps
//                         null, // organizationCode
//                         null, // organizationCode2
//                         null, // userProfile.email
//                         email // The specific created value you're looking for
//                     ]
//                 ),
//                 {size: size}
//             ),
//             q.Lambda('x', q.Get(q.Select(0, q.Var('x'))))
//         )
//     ).then((response) => {
//
//
//         if(response.data){
//             return response.data
//         }else{
//             throw new Error("Network error.");
//         }
//     })
// }

function getAllForUser(email, size=100){
    console.log(size)
    let token = localStorage.getItem("token");
    const supabase = dbClient(token)

    return supabase.from(collection).select('id,customerProfile,creator,lastEditBy,lastEditAt').or(`creator.eq.${email},lastEditBy.eq.${email}`)
        .then((response)=>{
        if(response.data){
            return response.data
        }else{
            throw new Error("Network error.");
        }
    }).catch((error) => {
            console.log(error)
            throw new Error("Request failed error.");
    })

    // return client.query(
    //
    //     q.Paginate(
    //         q.Union(
    //             [
    //                 q.Match(q.Index('needsAnalysis_for_creator_email'), email),
    //                 q.Match(q.Index('needsAnalysis_for_last_editor'), email),
    //             ]
    //         ),
    //
    //
    //         {size: size}
    //         )
    //     ).then((response) => {
    //
    //
    //     if(response.data){
    //         return response.data
    //     }else{
    //         throw new Error("Network error.");
    //     }
    // }).catch((error) => {
    //     console.log(error)
    // })
}


function getAll(selection = '*',size = 100){
    let token = localStorage.getItem("token");
    const supabase = dbClient(token)

    return supabase.from(collection).select(selection).order('lastEditAt',{ascending:false}).limit(size)
        .then((response)=>{
            if(response.data){
                return response.data
            }else{
                throw new Error("Network error.");
            }
        }).catch((error) => {
            console.log(error)
            throw new Error("Request failed error.");
        })

    // return client.query(
    //     q.Paginate(
    //         q.Match(
    //             q.Index(collection+"_by_ts_city_state_se_org_created")
    //         ),
    //         {size: size}
    //     ),
    // ).then((response) => {
    //
    //
    //     if(response.data){
    //         return response.data
    //     }else{
    //         throw new Error("Network error.");
    //     }
    // })
}

function load(recordId){
    let token = localStorage.getItem("token");
    const supabase = dbClient(token)

    return supabase.from(collection).select('*').eq('id',recordId).single()
        .then((response)=>{
            if(response.data){
                return response.data.data
            }else{
                throw new Error("Network error.");
            }
        }).catch((error) => {
            console.log(error)
            throw new Error("Request failed error.");
        })





    // return client.query(
    //     q.Get(q.Ref(q.Collection(collection), recordId))
    // ).then((response) => {
    //
    //
    //     if(response.data){
    //         let record = response.data;
    //         record.id = response.ref.value.id;
    //         return record;
    //     }else{
    //         throw new Error("Document error.");
    //     }
    // })
}

function responsesByQuestion(doc){
    let _responsesByQuestion = {};

    if(!(doc.responses)){
        return _responsesByQuestion;
    }
    let rKeys = Object.keys(doc.responses);

    if(rKeys.length){

        rKeys.forEach((rKey) => {
            let response = doc.responses[rKey];
            if(!_responsesByQuestion[response.question]){
                _responsesByQuestion[response.question] = {}
            }
            _responsesByQuestion[response.question][rKey] = response;
        })

        return _responsesByQuestion;
    }
    return _responsesByQuestion;

}



async function loadAllData(selection = "*", chunkSize = 100, onProgress) {

    try {
        let token = localStorage.getItem("token");
        const supabase = dbClient(token)
        const { count: totalRecords, error: countError } = await supabase.from(collection).select('id',{count: 'exact', head: true})
        if(countError){ throw countError }
        const totalPages = Math.ceil(totalRecords/chunkSize);
        let allData = []

        for(let page = 0; page < totalPages; page++) {
            const from = page * chunkSize;
            const to = from + chunkSize - 1;
            const {data, error} = await supabase.from(collection).select(selection).range(from,to)
            if(error){ throw error }

            allData = allData.concat(data)
            const progress = (page + 1) / totalPages;
            onProgress ? onProgress(progress, allData.length, totalRecords) : console.log('loaded ' + allData.length + ' of ' + totalRecords);
        }

        return allData;


    } catch(error) {
        alert("Error retrieving data");
        console.log("Load all records error",error);
        return []
    }
}

async function loadSomeData(selection = "*", chunkSize = 100) {

    try {
        let token = localStorage.getItem("token");
        const supabase = dbClient(token)
        const { data, error: error } = await supabase.from(collection).select(selection).limit(chunkSize)
        if(error){ throw error }
        return data;
    } catch(error) {
        alert("Error retrieving data");
        console.log("Load all records error",error);
        return []
    }
}

async function exportReport(onProgress) {


    const records = await loadAllData('*', 100, onProgress);

    let headers = [
        {group:"customerProfile",key:"organizationName",label:"Org Name",width:"32",heading:"Customer Profile"},
        {group:"created",key:"",label:"Created",width:"32", type: "date"},
        {group:"userProfile",key:"email",label:"Created By",width:"32"},
        {group:"lastEdit",key:"ts",label:"Last Edit",width:"32", type:"date"},
        {group:"lastEdit",key:"user",label:"Last Edit By",width:"32"},
        {group:"customerProfile",key:"organizationCode",label:"ORC CF Cust #:",width:"12"},
        {group:"customerProfile",key:"organizationCode2",label:"ORC CS Cust #:",width:"12"},
        {group:"customerProfile",key:"customerContact",label:"Customer Contact",width:"32"},
        {group:"customerProfile",key:"customerPhone",label:"Phone",width:"12"},
        {group:"customerProfile",key:"customerCell",label:"Cell",width:"12"},
        {group:"customerProfile",key:"address",label:"Address",width:"32"},
        {group:"customerProfile",key:"city",label:"City",width:"24"},
        {group:"customerProfile",key:"state",label:"State",width:"12"},
        {group:"customerProfile",key:"country",label:"Country",width:"18"},
        {group:"customerProfile",key:"postalcode",label:"Postal",width:"8"},
        {group:"customerProfile",key:"customerEmail",label:"Email",width:"32"},
        {group:"customerProfile",key:"itContact",label:"IT Contact",width:"32"},
        {group:"customerProfile",key:"itPhone",label:"IT Phone",width:"12"},
        {group:"customerProfile",key:"itEmail",label:"IT Email",width:"32"},
        {group:"customerProfile",key:"seName",label:"SE Name",width:"32"},
    ]

    let sectionList = [
        { label: "General Info", id: "generalInfo", sections:["generalInfo"]},
        { label: "Equipment", id: "equipment", sections:["equipment"]},
        { label: "Workflow", id: "workflow", sections:["workflow"]},
        { label: "Security", id: "security", sections:["security"]},
        { label: "Color", id: "color", sections:["color"]},
        { label: "Color Discovery", id: "colorDiscovery", sections:["colorDiscovery"]},
        { label: "Cross Media", id: "crossMedia", sections:["crossMedia"]},
        { label: "Industrial Print", id: "industrialPrint", sections:["industrialPrint"]},
        { label: "Advanced Solutions", id: "advancedSolutions", sections:["advancedSolutions"]},
        { label: "Advanced Finishing", id: "advancedFinishing", sections:["advancedFinishing"]},
    ]

    sectionList.forEach((sectionInfo)=>{

        let section = schema.sections[sectionInfo.id]
        section.groups.forEach((group, gIndex)=>{
            group.questions.forEach((qId, qIndex)=>{
                let col = {

                    group: "responses",
                    key: qId,
                    label: schema.questions[qId].label,
                    width: 0,
                    heading:(gIndex + qIndex)?"":section.label,
                }

                headers.push(col)
            })
        })


    })


    let report = records.map((record)=>{

        let responses = responsesByQuestion(record.data)

       return headers.map((header)=>{

           let val = ""
           if(header.group === "responses"){
               if(responses[header.key]){
                   let response = Object.keys(responses[header.key]).map((resId)=>{
                       return `${responses[header.key][resId].reviewer}\n${responses[header.key][resId].value}`
                   })

                   val = response.join("\n\n")
               }
               return val
           }



           if(header.key){
               val = record.data[header.group][header.key]
           }else{
               val = record.data[header.group]
           }
           if(header.type === 'date'){
               val = new Date(val).toLocaleDateString()
           }
           return val
       })
    })

    report.unshift(headers.map((header)=>{
        return header.label
    }))





    const worksheet = utils.aoa_to_sheet(report)
    worksheet["!cols"] = headers.map((header,index)=>{
        if(header.width){
            return {
                wch: report.reduce((w, r) => Math.max(w, r[index].length), 10)
            }
        }else{
            return {
                wch: 32
            }
        }

    })
    const workbook = utils.book_new()
    utils.book_append_sheet(workbook,worksheet,"Needs Analysis Data Export")
    writeFileXLSX(workbook,`Needs_Analysis_Export.xlsx`,{compression:true})

}

function generate(options){

    let created = Date.now();
    let record = {
        created: created,
        documentType: "Needs Analysis",
        admin: options.user.userid,
        user: options.user.userid,
        lastEdit: null,
        customerProfile: {
            "customerContact" : "",
            "customerEmail": "",
            "customerPhone": "",
            "customerCell": "",
            "assessmentDate" : "",
            "assessmentType" : options.customer.assessmentType,
            "address" : "",
            "organizationName" : options.customer.organizationName,
            "organizationCode": options.customer.organizationCode,
            "organizationCode2": options.customer.organizationCode2,
            "organizationId": options.customer.organizationId,
            "city" : "",
            "state" : "",
            "country" : "",
            "postalcode" : "",
            "email": "",
            "itContact": "",
            "itPhone":"",
            "itEmail":"",
            "seName":"",
            "pps":""
    },
        userProfile: options.user,
        answers: defaultAnswers(schema.questions),
        comments: defaultComments(schema.questions),
        sessions: {},
        responses: {},
        respondents: {

        },
        reviewers: {},
        notes: {
            background: {},
            summary: {},
            other: {}
        },
        exportSettings: {
            notes: {
                summary: true,
                background: true
            },
            respondents: [],
            departments: "all",
            showBlanks: true
        }
    }

    let defaultRespondent = generateRespondent();
    defaultRespondent.id = options.user.userid;
    defaultRespondent.title = options.user.title;
    defaultRespondent.reviewer = options.user.email;
    defaultRespondent.ts = Date.now();
    defaultRespondent.department = "notes"
    defaultRespondent.name = options.user.firstname + " " + options.user.lastname;

    record.respondents[options.user.userid] = defaultRespondent


    return record;
}

function update(recordId,record,user){

    console.log("saving...");



    if(recordId){

        let token = localStorage.getItem("token");
        const supabase = dbClient(token)


        record.lastEdit = {
            ts: new Date().toISOString(),
            user: user
        }

        console.log("saving...", recordId, record);

        return supabase.from(collection).update(
            {
                data: record,
                lastEditAt: record.lastEdit.ts,
                lastEditBy: record.lastEdit.user,
                customerProfile: record.customerProfile
            }
        ).eq('id',record.id)
            .then((response)=>{
                console.log('update', response)
                if(!response.error){
                    return response.data
                }else{
                    throw new Error(response.error?.message);
                }
            }).catch((error) => {
                console.log(error)
                throw new Error("Request failed error.");
            })
    }

}

function save(record,user){

    console.log("saving...");
    let token = localStorage.getItem("token");
    const supabase = dbClient(token)



    record.lastEdit = {
        ts: new Date().toISOString(),
        user: user
    }

    if(record.id){

        return supabase.from(collection).update(
            {
                data: record,
                lastEditAt: record.lastEdit.ts,
                lastEditBy: record.lastEdit.user,
                customerProfile: record.customerProfile
            }
        ).eq('id',record.id).select('id')
            .then((response)=>{
                if(response.data){
                    return response.data
                }else{
                    throw new Error(response.error?.message);
                }
            }).catch((error) => {
                console.log(error)
                throw new Error("Request failed error.");
            })

        // return client.query(
        //     q.Update(
        //         q.Ref(q.Collection(collection), record.id),
        //         {
        //             data: record
        //         }
        //     )
        // ).then((response) =>{
        //     return response;
        // })
    }else{

        const recId = crypto.randomUUID()
        record.id = recId;

        return supabase.from(collection).insert(
            {
                id: recId,
                data: record,
                creator: user,
                lastEditAt: record.lastEdit.ts,
                lastEditBy: record.lastEdit.user,
                customerProfile: record.customerProfile
            }
        ).select('id').then((response)=>{
            console.log('create needs',response);
                if(response.data){
                    return response.data
                }else{
                    throw new Error(response.error?.message);
                }
            }).catch((error) => {
                console.log(error)
                throw new Error("Request failed error.");
            })


        // return client.query(
        //     q.Create(
        //         q.Collection(collection),
        //         {
        //             data: record
        //         }
        //     )
        // ).then((response) =>{
        //     return response;
        // })
    }


}

function deleteRecord(recordId){
    let token = localStorage.getItem("token");
    const supabase = dbClient(token)

    return supabase.from(collection).delete().eq('id',recordId).then((response) =>{
        return response;
    })

}


export default {
    generate,
    save,
    load,
    update,
    getAll,
    loadAllData,
    loadSomeData,
    getAllForUser,
    getCount,
    exportReport,
    delete:deleteRecord,
    schema: schema,
    defaultAnswers: defaultAnswers,
    defaultComments: defaultComments,
    defaultAnswer: defaultAnswer,
    generateBlankComment,
    generateSession,
    generateRespondent
}
